import { useTranslation } from 'react-i18next'

export function useClassifiersTranslation(keyPrefix: string) {
  const { t } = useTranslation('classifiers', { keyPrefix })
  return t
}
